import React from 'react';

import { Flex, Stack } from '@atlaskit/primitives/compiled';

import type { AudioFeature } from '../../../types/audioFeature';
import { ModifyPlaylistButton } from '../playlist/ModifyPlaylistButtons';

import { AudioFeatureToggle } from './AudioFeatureToggle';
import { AudioHeader } from './AudioHeader';

export type AudioHeaderPanelProps = {
	featureList: AudioFeature[];
	activeFeature: AudioFeature;
	setActiveFeature: (feature: AudioFeature) => void;
};

export const AudioHeaderPanel = ({
	featureList,
	activeFeature,
	setActiveFeature,
}: AudioHeaderPanelProps) => {
	const getNextFeature = () => {
		const currentIndex = featureList.findIndex((feature) => feature.name === activeFeature.name);
		const nextIndex = (currentIndex + 1) % featureList.length;
		return featureList[nextIndex];
	};

	return (
		<Stack space="space.250" alignInline="center">
			<AudioHeader featureList={featureList} activeFeature={activeFeature} />
			<Flex gap="space.050" alignItems="center">
				<ModifyPlaylistButton
					isInPlaylist={true}
					addToPlaylist={() => {}}
					removeFromPlaylist={() => {}}
					round={true}
				/>
				<AudioFeatureToggle
					featureList={featureList}
					activeFeature={activeFeature}
					onClick={() => setActiveFeature(getNextFeature())}
				/>
			</Flex>
		</Stack>
	);
};
